import React, { Component } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ClientSingleItem from './clientSingleItem';
import ClientImg1 from "../../assets/static/img/client/client_img_1.png";

export class OurClientSayAboutUs extends Component {
    render() {
        const settings = {
            autoplay: true,
            dots: false,
            infinite: true,
            speed: 1500,
            autoplayspeed: 3500,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                }
              }
            ]

        };
        return (
            <div className="ourClientSayWrap" id="Testimonial">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="ourClientTopContent">
                                <h2 className="secTitle2 text-center"> Scholars say about us <span className="icon-surah1" data-reactid="44"></span> </h2>
                            </div>
                        </div>
                    </div>
                    <Slider className="row ourClientSlider" {...settings}>
                        <div className="col-12 ourClientSliderItem">
                            <ClientSingleItem ClientImg={ClientImg1} />
                        </div>
                        <div className="col-12 ourClientSliderItem">
                            <ClientSingleItem ClientImg={ClientImg1} />
                        </div>
                        <div className="col-12 ourClientSliderItem">
                            <ClientSingleItem ClientImg={ClientImg1} />
                        </div>
                        <div className="col-12 ourClientSliderItem">
                            <ClientSingleItem ClientImg={ClientImg1} />
                        </div>
                    </Slider>
                </div>
            </div>
        );
    }
}

export default OurClientSayAboutUs;
